"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _row = _interopRequireDefault(require("./row"));

var _wrap = _interopRequireDefault(require("./wrap"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var DropdownWrapper = /*#__PURE__*/function (_React$Component) {
  _inherits(DropdownWrapper, _React$Component);

  var _super = _createSuper(DropdownWrapper);

  function DropdownWrapper() {
    var _this;

    _classCallCheck(this, DropdownWrapper);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onMouseDown", function (e) {
      if (_this.props.open && _this.dropdownContainer && !_this.hasParent(e.target, 'tether-element')) {
        _this.onClose(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onKeydown", function (e) {
      if (_this.props.open && e.keyCode === 27) {
        _this.onClose(e);
      }
    });

    return _this;
  }

  _createClass(DropdownWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.onMouseDown, false);
      document.addEventListener('keydown', this.onKeydown, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.onMouseDown, false);
      document.removeEventListener('keydown', this.onKeydown, false);
    }
  }, {
    key: "hasParent",
    value: function hasParent(element) {
      if (!element.parentNode) return false;
      if (element.getAttribute('data-dropdown-wrap')) return true;
      return this.hasParent(element.parentNode);
    }
  }, {
    key: "onClose",
    value: function onClose(e) {
      this.props.onClose(e);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      if (!this.props.open) return null;else return /*#__PURE__*/_react.default.createElement(_wrap.default, {
        theme: this.props.theme,
        "data-test-id": "test-button-dropdown-dropdown",
        setRef: function setRef(ref) {
          return _this2.dropdownContainer = ref;
        }
      }, Array.isArray(this.props.content) ? /*#__PURE__*/_react.default.createElement("ul", {
        "data-test-id": "test-button-dropdown-list-render",
        className: "py1 px0 m0"
      }, this.props.content.map(function (button, i) {
        return /*#__PURE__*/_react.default.createElement(_row.default, {
          theme: _this2.props.theme,
          testID: "test-button-dropdown-row-".concat(i),
          key: i,
          isSubmenu: false,
          clickCloses: _this2.props.clickCloses,
          onClose: function onClose() {
            return _this2.onClose();
          },
          button: button
        });
      })) : /*#__PURE__*/_react.default.createElement("div", {
        "data-test-id": "test-button-dropdown-custom-render",
        onClick: function onClick(e) {
          if (typeof e.target.className === 'string' && _this2.props.classToClose !== '' && e.target.className.includes(_this2.props.classToClose)) {
            _this2.onClose(e);
          } else if (_this2.props.clickCloses) {
            _this2.onClose(e);
          }
        },
        className: "z1 relative"
      }, this.props.content));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return DropdownWrapper;
}(_react.default.Component);

DropdownWrapper.defaultProps = {
  theme: 'light',
  clickCloses: true,
  classToClose: ''
};
DropdownWrapper.propTypes = {
  open: _propTypes.default.bool.isRequired,
  clickCloses: _propTypes.default.bool,
  onClose: _propTypes.default.func.isRequired,
  content: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.string, _propTypes.default.array]).isRequired,
  style: _propTypes.default.object,
  theme: _propTypes.default.string,
  classToClose: _propTypes.default.string
};
var _default = DropdownWrapper;
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(DropdownWrapper, "DropdownWrapper", "/Users/darcy/sites/cs-theme/src/components/common/dropdown/index.js");
  reactHotLoader.register(_default, "default", "/Users/darcy/sites/cs-theme/src/components/common/dropdown/index.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();